import BillsDiscoveryReview from '../../../bills/components/BillsDiscoveryReview';

export default function BillsDiscoveryReviewScreen() {
    return <BillsDiscoveryReview />;
}
